import React, { useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { Divider } from "primereact/divider";
import { Message } from "primereact/message";
import { limitSize } from "../../constantes/appConstantes";
import { CounterString } from "../../componentes/CounterString";
import {
  enviarReserva,
  setValidarDenominacion,
  validarDenominacion,
} from "../../sliceRedux/Reserva.slice";
import { useSelector } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";

const Denominacion = (props) => {
  const { datos, formikEntidad, hideLoader, showLoader, dispatch } = props;
  const validarDenominacionResponse = useSelector((state) => state.reserva.validarDenominacion);

  const handleCaptchaVerify = () => {
    formikEntidad.setFieldValue("desactivarDisponibilidad", false);
  };

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && <small className="p-error">{formikEntidad.errors[name]}</small>
    );
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formikEntidad.touched[name] && formikEntidad.errors[name]);
    return isValid;
  };

  useEffect(() => {
    if (validarDenominacionResponse.code === 200) {
      formikEntidad.setFieldValue("desactivarOpciones", true);
      formikEntidad.setFieldValue("lstMensaje", validarDenominacionResponse?.object ?? []);
    }
    return () => {
      document.getElementById("nombreParticular")?.focus();
      hideLoader();
      dispatch(setValidarDenominacion({ ...validarDenominacionResponse, code: 0 }));
    };
  }, [validarDenominacionResponse.code]);

  const enviarDatosReserva = () => {
    showLoader();
    let data = {
      codCatTipoCaja: formikEntidad.values.tipoCaja,
      codCatVinculoComun: formikEntidad.values.tipoVinculo,
      numIdentificacion: datos?.identificacion,
      codCatTipoIdentificacion: datos?.idTipoIdentificacion,
      nombresPersona: datos?.nombres,
      codAbmPais: 1,
      codAbmProvincia: formikEntidad.values.provincia,
      codAbmCanton: formikEntidad.values.canton,
      codAbmParroquia: formikEntidad.values.parroquia,
      nombreParticular: formikEntidad.values.nombreParticular,
      callePrincipal: formikEntidad.values.callePrincipal,
      calleSecundaria: formikEntidad.values.calleSecundaria,
      numReferencia: formikEntidad.values.numero === "" ? null : formikEntidad.values.numero,
      referencia: formikEntidad.values.referencia === "" ? null : formikEntidad.values.referencia,
      traduccionCastellano:
        formikEntidad.values.traduccion === "" ? null : formikEntidad.values.traduccion,
      celularPersona: datos?.celular,
      telefonoPersona: datos?.telefono === "" ? null : datos?.telefono,
      correoPersona: datos?.email,
      nomArchivo: formikEntidad.values.nombreCroquis,
      croquis: formikEntidad.values.croquis,
      lstMensaje: formikEntidad.values.lstMensaje ?? [],
    };

    const formData = new FormData();
    formData.append("codCatTipoCaja", data.codCatTipoCaja);
    formData.append("codCatVinculoComun", data.codCatVinculoComun);
    formData.append("numIdentificacion", data.numIdentificacion);
    formData.append("codCatTipoIdentificacion", data.codCatTipoIdentificacion);
    formData.append("nombresPersona", data.nombresPersona);
    formData.append("codAbmPais", data.codAbmPais);
    formData.append("codAbmProvincia", data.codAbmProvincia);
    formData.append("codAbmCanton", data.codAbmCanton);
    formData.append("codAbmParroquia", data.codAbmParroquia);
    formData.append("nombreParticular", data.nombreParticular);
    formData.append("callePrincipal", data.callePrincipal);
    formData.append("calleSecundaria", data.calleSecundaria);
    if (data.numReferencia !== null) formData.append("numReferencia", data.numReferencia);
    if (data.referencia !== null) formData.append("referencia", data.referencia);
    if (data.traduccionCastellano !== null)
      formData.append("traduccionCastellano", data.traduccionCastellano);
    formData.append("celularPersona", data.celularPersona);
    if (data.telefonoPersona !== null) formData.append("telefonoPersona", data.telefonoPersona);
    formData.append("correoPersona", data.correoPersona);
    formData.append("nomArchivo", data.nomArchivo);
    formData.append("croquis", data.croquis);
    formData.append("lstMensaje", JSON.stringify(data.lstMensaje));
    dispatch(enviarReserva(formData));
  };
  return (
    <>
      <div className="card">
        <form onSubmit={formikEntidad.handleSubmit}>
          <Fieldset legend="Solicitud de Reserva Denominación">
            <div className="grid">
              <div className="flex col-12 md:col-6">
                <label
                  htmlFor="tipoIdentificacion"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Tipo de identificación:
                </label>

                <InputText
                  id="tipoIdentificacion"
                  name="tipoIdentificacion"
                  value={datos?.nomCatalogoIdentificacion ?? ""}
                  style={{ width: "100%" }}
                  disabled
                />
              </div>

              <div className="flex col-12 md:col-6">
                <label
                  htmlFor="identificacion"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Identificación:
                </label>
                <InputText
                  id="identificacion"
                  name="identificacion"
                  value={datos?.identificacion ?? ""}
                  style={{ width: "100%" }}
                  disabled
                />
              </div>

              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="nombres"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Apellidos y Nombres:
                </label>

                <InputText
                  id="nombres"
                  name="nombres"
                  value={datos?.nombres ?? ""}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>

              <div className="flex col-12 md:col-6">
                <label
                  htmlFor="tipoCajaDescripcion"
                  className="mr-2"
                  style={{ minWidth: "140px", textAlign: "left" }}
                  required
                >
                  Tipo de caja:
                </label>

                <InputText
                  id="tipoCajaDescripcion"
                  name="tipoCajaDescripcion"
                  value={formikEntidad.values.tipoCajaDescripcion}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>

              <div className="flex col-12 md:col-6">
                <label
                  htmlFor="vinculoComunDescripcion"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Tipo de vínculo común:
                </label>

                <InputText
                  id="vinculoComunDescripcion"
                  name="vinculoComunDescripcion"
                  value={formikEntidad.values.vinculoComunDescripcion}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <Divider />
            <div className="formgrid grid">
              <div className="field col-12 md:col-6">
                <div className="col">
                  <label className="font-semibold">Denominación: </label>
                  <div className="font-bold uppercase m-2">
                    {formikEntidad.values.tipoCajaDescripcion +
                      " - " +
                      formikEntidad.values.nombreParticular}
                  </div>
                </div>
                <div className="col">
                  <label htmlFor="traduccion">Traducción al Castellano:</label>
                  <InputTextarea
                    id="traduccion"
                    name="traduccion"
                    value={formikEntidad.values.traduccion}
                    maxLength={limitSize.TEXT_INPUT_DEFECTO}
                    rows={2}
                    autoComplete="off"
                    onChange={(e) => {
                      formikEntidad.setFieldValue("traduccion", e.target.value.toUpperCase());
                    }}
                    style={{ width: "100%" }}
                  />
                  <CounterString
                    length={formikEntidad.values.traduccion.length}
                    maxLength={limitSize.TEXT_INPUT_DEFECTO}
                  />
                </div>

                <div className="col">
                  <div className="font-semibold uppercase m-2">
                    Su Razón Social será:{" "}
                    {formikEntidad.values.tipoCajaDescripcion +
                      " " +
                      formikEntidad.values.nombreParticular}
                  </div>
                </div>
              </div>
              <div className="field col-12 md:col-6">
                <div className="field col-12 md:col-12">
                  <label htmlFor="nombreParticular" required>
                    Nombre particular:
                  </label>
                  <InputTextarea
                    id="nombreParticular"
                    name="nombreParticular"
                    value={formikEntidad.values.nombreParticular}
                    maxLength={limitSize.TEXT_INPUT_NOMBRE}
                    autoComplete="off"
                    rows={2}
                    onBlur={formikEntidad.handleBlur}
                    onChange={(e) => {
                      formikEntidad.setFieldValue("lstMensaje", []);
                      formikEntidad.setFieldValue("nombreParticular", e.target.value.toUpperCase());
                      formikEntidad.setFieldValue("desactivarOpciones", false);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("nombreParticular")}
                  <CounterString
                    length={formikEntidad.values.nombreParticular.length}
                    maxLength={limitSize.TEXT_INPUT_NOMBRE}
                  />
                </div>
                <div className="col">
                  {formikEntidad.values.lstMensaje?.length > 0 &&
                    formikEntidad.values.lstMensaje?.map((item, index) => (
                      <Message key={index} severity="warn" className="mb-2" text={item.mensaje} />
                    ))}
                </div>
              </div>
            </div>

            {formikEntidad.values.desactivarDisponibilidad && (
              <HCaptcha
                sitekey="79ff2a71-b636-4833-af19-d53fd93eff78"
                onVerify={handleCaptchaVerify}
              />
            )}
            <div className="flex justify-content-center pm-3">
              <Button
                label="Disponibilidad solicitud de reserva"
                icon="pi pi-search"
                severity="secondary"
                className="mr-3"
                type="submit"
                disabled={
                  formikEntidad.values.desactivarDisponibilidad ||
                  formikEntidad.values.desactivarOpciones
                }
                onClick={(e) => {
                  if (formikEntidad.values.nombreParticular === "") {
                    formikEntidad.setFieldError("nombreParticular", "Este campo es obligatorio");
                    e.preventDefault();
                  } else {
                    let data = {
                      nombreParticular: formikEntidad.values.nombreParticular,
                      esPertenencia: formikEntidad.values.esPertencia === "S" ? true : false,
                    };
                    showLoader();
                    dispatch(validarDenominacion(data));
                  }
                }}
              />
              {formikEntidad.values.desactivarOpciones && (
                <Button
                  label="Enviar"
                  icon="pi pi-send"
                  className="mr-3"
                  severity="success"
                  iconPos="right"
                  type="submit"
                  onClick={(e) => {
                    let warningMessage = "";
                    if (formikEntidad.values.lstMensaje?.length > 0) {
                      warningMessage = (
                        <>
                          <Message
                            severity="info"
                            className="font-semibold m-2"
                            text="Se informa que tiene coincidencias con 1 o más entidades del sector financiero por lo cual la solicitud podría ser rechazada ."
                          />
                          <br />
                        </>
                      );
                    }
                    confirmDialog({
                      message: (
                        <div className="d-flex flex-column align-items-center text-center">
                          {warningMessage}
                          <span className="font-semibold">
                            ¿Está seguro de enviar la solicitud de reserva?
                          </span>
                        </div>
                      ),
                      header: "Confirmación",
                      icon: "pi pi-exclamation-triangle",
                      acceptLabel: "Si",
                      icon: null,
                      rejectLabel: "No",
                      rejectIcon: "pi pi-times",
                      acceptIcon: "pi pi-check",
                      rejectClassName: "p-button-secondary",
                      accept: () => enviarDatosReserva(),
                      reject: () => null,
                    });
                  }}
                />
              )}
            </div>
          </Fieldset>
        </form>
      </div>
    </>
  );
};
export default Denominacion;
